"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _tackleLoaderSymbol = _interopRequireDefault(require("../../images/tackle-loader-symbol"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var centerStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};
var psuedoStyles = {
  content: "''",
  display: 'block',
  height: '80%',
  width: '80%',
  borderStyle: 'solid',
  borderColor: 'rgba(0, 0, 0, 0.75)',
  borderWidth: '2px',
  borderRadius: '50%',
  willChange: 'width, height, opacity, border-width',
  zIndex: 1,
  animationDuration: '3s',
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite'
};
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    '@keyframes grow': {
      from: {
        width: '80%',
        height: '80%',
        opacity: 1,
        borderWidth: '2px'
      },
      to: {
        width: '500%',
        height: '500%',
        opacity: 0,
        borderWidth: '0px'
      }
    },
    container: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%'
    },
    root: _objectSpread(_objectSpread({}, centerStyles), {}, {
      '&::before': _objectSpread(_objectSpread(_objectSpread({}, centerStyles), psuedoStyles), {}, {
        animationName: '$grow',
        animationDelay: '0s'
      }),
      '&::after': _objectSpread(_objectSpread(_objectSpread({}, centerStyles), psuedoStyles), {}, {
        animationName: '$grow',
        animationDelay: '2s'
      })
    }),
    img: {
      position: 'relative',
      zIndex: 2,
      width: '70%',
      height: '70%',
      fontSize: '10vh',
      display: 'flex',
      margin: 0,
      justifyContent: 'center',
      alignItems: 'center',
      transform: 'scale(1.5)'
    }
  };
});

// TODO refactor to use Canvas animation if approved
var Loader = function Loader() {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container,
    "data-testid": "tackleLoader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.img
  }, /*#__PURE__*/_react.default.createElement(_tackleLoaderSymbol.default, null))));
};
var _default = Loader;
exports.default = _default;